import {get32} from './get32.js';

/** 0 */
export const min = get32(0x00_00_00_00);

/** 2^64 - 1 */
export const max = get32(0xff_ff_ff_ff);
